export function coordsType(coords) {
  return coords.type || coords.Type;
}

export function isStraightRectangleCoords(coords) {
  coords = coords?.coordinates?.[0];
  return Array.isArray(coords) && coords.length === 5
    // First and last vertex match
    && coords[0]?.[0] === coords[4]?.[0] // First/last long/x
    && coords[0]?.[1] === coords[4]?.[1] // First/last lat/y
    // Note: first corner is bottom-left
    && coords[0]?.[0] === coords[1]?.[0] // Left long/x
    && coords[1]?.[1] === coords[2]?.[1] // Top lat/y
    && coords[2]?.[0] === coords[3]?.[0] // Right long/x
    && coords[3]?.[1] === coords[4]?.[1] // Bottom lat/y
  ;
}

export function isPointCoords(coords) {
  return coordsType(coords) === 'Point';
}

export function isLineCoords(coords) {
  return coordsType(coords) === 'LineString';
}

export function isBoxCoords(coords) {
  return coordsType(coords) === 'Polygon' && isStraightRectangleCoords(coords);
}

export function isPolygonCoords(coords) {
  return coordsType(coords) === 'Polygon';
}
